const translations = {
  "footer.aboutUs": "About us",
  "footer.career": "Career",
  "footer.financialData": "Financial information",
  "footer.moreAboutInsurance": "Learn more about insurance",
  "footer.offices": "Offices",
  "footer.feedback": "Feedback",
  "footer.address": "#9 Ana Politkovskaia St.",
  "footer.ourTeam": "Our team",
  "footer.legalInformation": "Legal information",
  "footer.onlineCenter": "Online assistance",
  "footer.contact": "Contact",
  "main.callUs": "Call us",
  "main.messageUs": "Message us",
  "myProfile.insured": "Insured",
  "myProfile.children": "Children",
  "myProfile.parent": "Parent",
  "myProfile.addChild": "Add child",
  "myProfile.checkProfile": "Check the profile",
  "myProfile.changePassword": "Change the password",
  "myProfile.exit": "Exit",
  "myProfile.persNumber": "Personal number",
  "myProfile.birthDate": "Month/day/year",
  "myProfile.childAgeWarningText": `It is not possible to add a child. You can only add a person whose age does not exceed 14 years.`,
  "myProfile.ageLaw":
    "For the purpose of complying with the requirements of the Law on Patient Rights, you will only be able to add a person who is under the age of 14",
  "myProfile.smsForInsurer":
    "Send SMS to the phone number of the child's policy holder",
  "myProfile.next": "Next",
  "myProfile.addManually": "Add manually",
  "myProfile.pleaseEnter1": "Please specify",
  "myProfile.pleaseEnter2": "SMS code sent to the phone number",
  "myProfile.smsCode": "Sms code",
  "myProfile.againCode": "Send SMS code again",
  "myProfile.addedSuccess": "Child's profile is successfully added",
  "myProfile.pleaseCheckProfile": "Please see “My profile”",
  "myProfile.oldPassword": "Old password",
  "myProfile.newPassword": "New password",
  "myProfile.repeatPassword": "Repeat the password",
  "myProfile.save": "Save",
  "breadCrumb.portal": "Home",
  "breadCrumb.service-center": "Register in the Service Center",
  "breadCrumb.account": "My profile",
  "breadCrumb.policy": "My policies",
  "breadCrumb.providers": "Provider clinics and offers",
  "breadCrumb.travel": "Travel insurance",
  "breadCrumb.questionary": "Questionnaire",
  "breadCrumb.med-history": "My medical history",
  "breadCrumb.compensations": "Request of reimbursement",
  "breadCrumb.personal-doctor": "Family doctor",
  //temporary addition
  "breadCrumb.appeals": "Referrals",
  "breadCrumb.hospitalGuarantee": "Inpatient guarantee",

  "breadCrumb.profile-doctor": "Booking doctor's appointment",
  "myProfile.myProfile": "My profile",
  "myProfile.myIncurence": "My insurance",
  "myProfile.myPolicies": "My policies",
  "myProfile.myMedHistory": "My medical history",
  "myProfile.myProvClinics": "My provider clinics",
  "myProfile.appointmentDoctor": "Booking doctor's appointment",
  "myProfile.remoteServices": "Remote services",
  "myProfile.appeals": "Referrals",
  "myProfile.moneyRefund": "Reimbursement",
  "myProfile.bookingServiceCenter": "Register in the Service Center",
  "myProfile.insuranceProducts": "Insurance products",
  "myProfile.travelInsurance": "Travel insurance",
  "profileMain.activeOffers": "Active offers",
  "profileMain.offerDescription": "Offer description",
  "profileMain.seeAll": "See all",
  "profileMain.startIncurance1": "Book an appointment",
  "profileMain.startIncurance2": "with your",
  "profileMain.startIncurance3": "family doctor via",
  "profileMain.startIncurance4": "Messenger Chat Bot",
  "profileMain.currentAppeals": "Current referrals",
  "profileMain.refunds": "Refund requests",
  "profileMain.scheduledConsultations": "Scheduled consultations",
  "profileMain.myDoctor": "My doctor",
  "profileMain.myManager": "My manager",
  "profileMain.validityPeriod": "Validity period",
  "profileMain.until": "Until",
  "profileMain.active": "Active",
  "profileMain.appealNo": "Referral No.",
  "profileMain.policyNo": "Policy No.",
  "profileMain.appealType": "Referral type",
  "profileMain.policyService": "Policy service",
  "profileMain.medicalService": "Medical service",
  "profileMain.medicamentName": "Medication Name",
  "profileMain.quantity": "Amount quantity",
  "profileMain.amount": "Amount",
  "profileMain.providerClinic": "Provider clinic",
  "profileMain.insuranceShare": "Insurance share",
  "profileMain.barcode": "Referral barcode",
  "profileMain.uploadedDoc": "Uploaded Medical documentation",
  "profileMain.file": "File",
  "profileMain.correctComment": "Correction comment",
  "profileMain.createDate": "Created date",
  "profileMain.extendAppeal": "Referral Extension",
  "profileMain.specialist": "Specialist",
  "profileMain.validUntil": "Expiry date",
  "profileMain.recommendPasswordChange":
    "We recommend you to set your own password",
  "profileMain.yourMailIs1": "Your e-mail address is",
  "profileMain.yourMailIs2":
    "If you want to change current address, please, go to the page “My Profile”",
  "profileMain.yourMailIs3":
    "If you want to add your e-mail address, please, go to the page “My Profile”",
  "profileMain.agree": "Confirm",
  "profileMain.back": "Back",
  "profileMain.childRemoved1":
    "The child added to your insurance profile has turned 14",
  "profileMain.childRemoved2":
    "For the purpose of complying with the requirements of the law regarding the rights of patients, You can only use the profile of a person whose age does not exceed 14 years.",
  "profileMain.childRemoved3":
    "The insured has an individual account on portal: ",
  "profileMain.agreed": "Agree",
  "profileMain.changePolicy": "Change policy",
  "profileMain.consultationModalTitle":
    "Do you need a Medical Specialist consultation?",
  "profileMain.consultationModal":
    "With just a few clicks, receive an SMS referral to an Ophthalmologist, Dermatologist, Neurologist and other specialists from the",
  "profileMain.consultationModalUrl": "Portal",
  "profileMain.getItOnAppStore": "Get it on App Store And Google Play",
  "profileMain.reimbursementService": "Medical service provided",

  "profileMain.uploadDoc": "Documents to be uploaded",
  "profileMain.fileSizeTooBigText":
    "size of uploaded documents is larger than 100 megabytes, please change their size",
  "profileMain.send": "Send",
  "profileMain.ConsiderTheSubmittedDocuments":
    "I don't have the requested document, consider without it",
  "profileMain.successResendingRemunerationRequest":
    "Documentation has been sent successfully!",
  "profileMain.failedResendingRemunerationRequest1": "An error occurred!",
  "profileMain.failedResendingRemunerationRequest2":
    "Please try to upload the documentation again",

  "dashboardAppeals.ReferralIsActive": "Referral is active",
  "dashboardAppeals.referralIsAlreadyExtended": "Referral is already extended",
  "dashboardAppeals.cannotBeExtended": `Unfortunately, the referral cannot be extended! The referral has already been used`,
  "dashboardAppeals.extensionDeadlineHasExpired":
    "Unfortunately, the referral extension deadline has expired",
  "dashboardAppeals.deadlineCannotBeExtendedWithImmuneVacinations": `Unfortunately, the deadline for referrals issued through the immunization/vaccination service cannot be extended.`,
  "dashboardAppeals.serviceLimitHasExpired": `Unfortunately, the referral cannot be extended! The service limit on the policy has expired.`,
  "dashboardAppeals.recordNotFound": "Record not found",
  "dashboardAppeals.mainErrorMessage":
    "Unfortunately, the referral period  cannot be extended!",
  "dashboardAppeals.mainSuccessMessage":
    "the referral period has been successfully extended!",
};

export default translations;
